import { forwardRef } from 'react'

import {
  NativeSelectField,
  NativeSelectIndicator,
  NativeSelectRoot,
} from '@enechain/ecloud-designsystem'

export type SelectOption = {
  value: string | number
  label: string
}

export const enumSetValueAs = (raw: unknown): number | undefined => {
  if (raw === '' || raw === null || raw === undefined) return undefined
  const num = typeof raw === 'number' ? raw : Number(raw)
  return Number.isNaN(num) ? undefined : num
}

type EnumSelectProps = {
  options: SelectOption[]
  placeholder?: string
  size?: 'xs' | 'sm' | 'md' | 'lg'
} & Omit<React.ComponentPropsWithoutRef<'select'>, 'children' | 'size'>

/**
 * 既定 size は `md` (= 高さ 40px)。 design/css/components.css の `.ecl-select` /
 * `.ecl-select--sm` はどちらも height 40px / font 14px で、 `--sm` は左右 padding
 * だけが縮む (2756-2775 行)。 chakra の `sm` (36px) では design と高さが合わない。
 *
 * 文字サイズは size では決まらない: chakra の nativeSelect recipe が field へ渡す
 * `textStyle: 'sm'` は本 app の system で ecloud の sm (12px) に解決されてしまうため、
 * design の md (14px) を `textStyle="md"` で明示する。
 */
export const EnumSelect = forwardRef<HTMLSelectElement, EnumSelectProps>(
  ({ options, placeholder, size = 'md', ...selectProps }, ref) => (
    <NativeSelectRoot size={size}>
      <NativeSelectField ref={ref} textStyle="md" {...selectProps}>
        {placeholder !== undefined && <option value="">{placeholder}</option>}
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </NativeSelectField>
      <NativeSelectIndicator />
    </NativeSelectRoot>
  ),
)

EnumSelect.displayName = 'EnumSelect'
